import BasicLayout from "../../layout/curr.vue"
// const pre = ' - 极客轻商城系统';
const meta = {
    auth: true
};

export default {
    path: 'shop',
    name: 'shop',
    component: BasicLayout,
    children: [{
            path: 'group',
            name: "shop-group",
            component: () => import("@/pages/admin/shop/group.vue"),
            meta: {
                ...meta,
                title: '分类管理 - 极客商城系统'
            }

        }, {
            path: 'add',
            name: "shop-add",
            component: () => import("@/pages/admin/shop/add.vue"),
            meta: {
                ...meta,
                title: '添加商品 - 极客商城系统'
            }

        }, {
            path: 'add/:id',
            name: "shop-list",
            component: () => import("@/pages/admin/shop/add.vue"),
            meta: {
                ...meta,
                title: '编辑商品 - 极客商城系统'
            }

        }, {
            path: 'list',
            name: "shop-list",
            component: () => import("@/pages/admin/shop/list.vue"),
            meta: {
                ...meta,
                title: '商品列表 - 极客商城系统'
            }
        },
        {
            path: "*",
            redirect: '/home'
        },
    ]
};